import { render, staticRenderFns } from "./WidgetRankingVsLevel.vue?vue&type=template&id=07bed09c&"
import script from "./WidgetRankingVsLevel.vue?vue&type=script&lang=js&"
export * from "./WidgetRankingVsLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports